import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { GenerateAssetsFromGrnPage } from "@/features/assets/GenerateAssetsFromGrnPage";
import { ReceiveGrnToStorePage } from "@/features/grns/ReceiveGrnToStorePage";
import { useGrn } from "@/features/grns/api";

export const Route = createFileRoute("/_authenticated/grns/$grnId/generate-assets")({
  component: GenerateAssetsPage,
});

function GenerateAssetsPage() {
  const { grnId } = Route.useParams();
  const { data: grn, isLoading } = useGrn(grnId);
  if (isLoading || !grn) {
    return <div className="grid place-items-center p-10"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  }
  if (grn.kind !== "asset") {
    return <ReceiveGrnToStorePage grnId={grnId} />;
  }
  return <GenerateAssetsFromGrnPage grnId={grnId} />;
}
